module.exports = __webpack_public_path__ + "img/new-logo-full.48a4503.png";